import { useCallback } from "react";
import { trpc } from "../../../lib/api/trpc";

/**
 * Hook for self-service reprocessing of a failed/suspect document (Phase 14).
 * Admin-only on the server; the UI gates the button via `canReprocess`.
 */
export const useReprocessDocument = () => {
  // @ts-ignore - trpc context typing
  const utils = trpc.useContext();

  // @ts-ignore - trpc.documents typing
  const { mutateAsync, isLoading, isError, error, isSuccess, reset } =
    trpc.documents.reprocess.useMutation({
      onSuccess: (_data: unknown, variables: { id: string }) => {
        // @ts-ignore - utils.documents typing
        utils.documents.get.invalidate({ id: variables.id });
        // @ts-ignore - utils.documents typing
        utils.documents.list.invalidate();
      },
    });

  const reprocessDocument = useCallback(
    async (documentId: string) => {
      try {
        const result = await mutateAsync({ id: documentId });
        return { success: true, result };
      } catch (err: any) {
        return {
          success: false,
          error: err?.message || "Failed to reprocess document",
        };
      }
    },
    [mutateAsync],
  );

  return {
    reprocessDocument,
    isLoading,
    isError,
    error,
    isSuccess,
    reset,
  };
};
